import { graphql } from "@opensea/graphql"
import { getCollectionSweepQuoteErrorFragment } from "../../../../../components/CollectionSweepQuoteReceipt/getCollectionSweepQuoteError.fragment"

export const CollectionSweepFlowTimeline_quoteFragment = graphql(
  `
    fragment CollectionSweepFlowTimeline_quote on CollectionSweepQuoteResponse {
      collection {
        chain {
          identifier
        }
      }

      quote {
        ...getCollectionSweepQuoteError

        __typename
        ... on CollectionSweepQuoteSuccess {
          itemQuotes {
            pricePerItem {
              token {
                unit
                symbol
                address
                chain {
                  identifier
                }
              }
              usd
            }
          }
        }
      }
    }
  `,
  [getCollectionSweepQuoteErrorFragment],
)
